import React from 'react';
import { Loader, useToasts } from 'freemium-ui';
import { useHistory } from 'react-router-dom';
import { useGetAccountInfo, useLogin } from '../../../shared/hooks';
import { Center } from '../../../shared/styles';

const FreshidLogin = () => {
  const [, setToast] = useToasts();
  const history = useHistory();
  const authToken = window.localStorage.getItem('authToken');

  const { mutate: login } = useLogin({
    setToast,
    callback: (success: boolean, response: any) => {
      if (success) {
        if (response.redirect_url) window.location.href = response.redirect_url;
      }
    },
  });

  useGetAccountInfo({
    enabled: Boolean(authToken),
    callback: (success: boolean) => {
      if (success) {
        history.push('/survey');
      } else {
        login({
          domain: window.location.host,
        });
      }
    },
  });

  React.useEffect(() => {
    login({
      domain: window.location.host,
    });
  }, []);

  return (
    <Center>
      <Loader />
    </Center>
  );
};

export default FreshidLogin;
